import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import ExampleCard from './components/ExampleCard';

const MateriasPage = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Materias</h3>
      </Col>
    </Row>
    <Row>
      <ExampleCard />
    </Row>
    <Row>
      <ExampleCard />
    </Row>
  </Container>
);

export default MateriasPage;
